import { Mutation, Query } from '@apollo/client/react/components';
import React, { Component, Fragment } from 'react';
import { deleteUser, updateUser, getUser } from './api';

import Navbar from '../../../components/Navbar';
import { Loader } from '../../../components/Loader';
import UserForm from '../../../components/UserForm';
import { RedirectModal } from './components/RedirectModal';
import { ErrorMessage } from '../../../components/ErrorMessage';
import { Modal, Button } from 'react-bootstrap';

class EditUser extends Component {
  formatRoles = (roles, defaultRole) => {
    let applicationUserRoles = roles.map((role) => {
      return role.departments.map((department) => {
        return {
          department: {
            id: department.id,
            Name: department.Name,
          },
          role: {
            id: role.roleId,
            roleType: role.roleType,
          },
          isDefaultRole: defaultRole.roleId === role.roleId && defaultRole.departmentId === department.id ? true : false,
        };
      });
    });
    return applicationUserRoles.reduce((acc, role) => acc.concat(role), []);
  };

  mutationHandler = (formData, mutation) => {
    let applicationUserRoles = this.formatRoles(formData.roles, formData.defaultRole);
    const { user } = formData;
    mutation({
      variables: {
        id: user.id,
        isDevTeam: false,
        name: user.name,
        // adId: user.adId,
        active: user.active,
        mailStop: user.mailStop,
        emailAddress: user.email,
        sendEmail: user.sendEmail,
        applicationUserRoles,
      },
    });
  };

  updatingUser = (loading, data) => {
    if (loading) {
      return (
        <Modal show={true}>
          <Loader title='Updating User' />
        </Modal>
      );
    } else if (data.updateUser) {
      return <RedirectModal title='User was updated' body='Where would you like to go?' />;
    } else {
      alert('There was an error trying to update this user.');
    }
  };

  redirect = (data, called, loading) => {
    if (called && !loading) {
      if (data.deleteUser) return <RedirectModal title='User was deleted' body='Where would you like to go?' />;
      else {
        alert('An error occurred while trying to delete this user.');
        return null;
      }
    } else {
      return null;
    }
  };

  deleteUserButton = (id) => {
    return (
      <Mutation mutation={deleteUser}>
        {(deleteUser, { loading, data, called }) => (
          <Fragment>
            <Button className='mt-3 float-right' onMouseUp={() => deleteUser({ variables: { id } })}>
              Delete User
            </Button>
            {this.redirect(data, called, loading)}
          </Fragment>
        )}
      </Mutation>
    );
  };

  render() {
    return (
      <Fragment>
        <Navbar />
        <Query query={getUser(this.props.match.params.id)} fetchPolicy='no-cache'>
          {({ loading, error, data }) => {
            if (loading) return <Loader title='Loading User.' />;
            if (error) {
              return <ErrorMessage title={`This user does not exist. ${error}`}  />;
            }
            let userData = data.readOneApplicationUser;
            return (
              <Mutation mutation={updateUser}>
                {(mutation, { loading, data, called }) => (
                  <Fragment>
                    <UserForm
                      title='Edit User'
                      type={2}
                      user={userData}
                      leftAction={(formData) => this.mutationHandler(formData, mutation)}
                      rightAction={this.deleteUserButton(parseInt(userData.id))}
                      leftText='Update User'
                      rightText='Delete User'
                    />
                    {called ? this.updatingUser(loading, data) : null}
                  </Fragment>
                )}
              </Mutation>
            );
          }}
        </Query>
      </Fragment>
    );
  }
}

export default EditUser;
